import { Component, Input } from '@angular/core';
import { DeviceLocationDeviceDetail } from '../shared/models/device-location-device-detail.interface';
import { IBusyFirmwareStatusViewInfo, IFirmwareStatusViewInfo } from '../shared/models/models';
import { FirmwareUpdateStatusViewInfoService } from './firmware-update-status-view-info.service';
import FirmwareImageStatus = CASLink.Device.Ui.ViewModel.Device.FirmwareImageStatus;
import * as _ from 'lodash';

@Component({
    selector: 'dl-device-status-pending-version-cell',
    templateUrl: './device-status-pending-version-cell.component.html',
    styleUrls: ['./device-status-pending-version-cell.component.scss']
})
export class DeviceStatusPendingVersionCellComponent {
    public static $name: string = 'clDeviceStatusPendingVersionCell';

    @Input() item: DeviceLocationDeviceDetail;
    private oldItem: DeviceLocationDeviceDetail;


    protected state: IBusyFirmwareStatusViewInfo | IFirmwareStatusViewInfo;
    protected tooltipDirection: string = 'right';

    get isStatusAvailable(): boolean {
        return this.item?.firmwareUpdateStatus &&
            (this.item?.firmwareUpdateStatus !== FirmwareImageStatus.Previous && this.item?.firmwareUpdateStatus !== FirmwareImageStatus.Current);
    }

    constructor(
        private firmwareUpdateStatusViewInfoService: FirmwareUpdateStatusViewInfoService) {
    }

    ngOnInit() {
        this.oldItem = null; // it is very important to have oldItem not been equal to Item cos then state would never get set initially
    }

    ngDoCheck() {
        if (!(_.isEqual(this.oldItem, this.item))) {
            this.state = this.firmwareUpdateStatusViewInfoService.getState(this.item);
            this.oldItem = _.cloneDeep(this.item);
        }
    }

    get stateIsBusy() {
        return this.isBusy(this.state);
    }

    isBusy(x: IBusyFirmwareStatusViewInfo | IFirmwareStatusViewInfo): x is IBusyFirmwareStatusViewInfo  {
        return x?.status === FirmwareImageStatus.Busy;
    }



    get versionProgressMode(): 'determinate' | 'indeterminate' {
        if (this.isBusy(this.state) && this.arePagesValid(this.state)) {
            return 'determinate';
        }

        return 'indeterminate';
    }

    get versionProgressValue(): number {
        if (this.isBusy(this.state) && this.arePagesValid(this.state)) {
            // tslint:disable-next-line:no-magic-numbers
            return Math.round((this.state.currentPage / this.state.totalPages) * 100);
        }

        return 0;
    }

    private arePagesValid(item: IBusyFirmwareStatusViewInfo) {
        return item?.currentPage !== undefined && item?.totalPages !== undefined && item?.currentPage !== 0 && item?.totalPages !== 0;
    }
}
